import * as angular from 'angular';

class StorageAdminPremiumServicesComponentCtrl implements ng.IController {}

angular.module('app').component('pkpStorageAdminPremiumServices', {
    controller: StorageAdminPremiumServicesComponentCtrl,
    template:
        require('app/storage-admin/storage-admin-premium-services.component.html'),
    bindings: {}
});
